export default {
    "ins_1": "«Урматтуу кардар, картаңызга акча алуу үчүн, төмөнкү көрсөтмөлөрдү аткарыңыз: ",
    "ins_1_1": "Жеке эсебиңизди жана туулган күнүңүздү киргизиңиз",
    "ins_2": "Сиздин жеке эсебиңизди Өнөктөштөр аркылуу микрокредиттерди төлөө ыкмалары документинен же М Булактагы адисиңизден билсеңиз болот",
    "ins_3": "Эгер сиз киргизген маалымат туура болсо, \"Кийинки\" баскычын басыңыз",
    "warn": "Көңүл буруңуз!",
    "warn_1": "Эгер билдирүүдө сиздин толук аты-жөнүңүз жок болсо, M Булaк адисине кайрылыңыз.",
    "warn_2": "Эгер сиз бул билдирүүнү жаңылыштык менен ачкан болсоңуз, буга көңүл бурбаңыз жана эч кандай маалымат киргизбеңиз.",
    "warn_3": "Эгер сиз көрсөтмөлөрдү так аткарып, бардыгын туура киргизип, бирок телефонуңуздун номуруна Кодду алган жок болсоңуз, анда М Булактагы адисиңизге кайрылыңыз.",
    "warn_4": "Эгерде сиз бардык нерсени туура жана толук аткарсаңыз, көрсөтмөлөрдүн шарттарын так сактап, киргизилген маалыматтардын тууралыгын тастыктоо үчүн, көрсөтүлгөн картаңыздан 1 рубль алынат. Операцияны ырастагандан кийин 10 мүнөттүн ичинде 1 рубль сиздин картаңызга кайра кайтарылат.",
    "birthday": "Туулган күнүңүздү киргизиңиз",
    "account": "Өздүк эсеп",
    "digit_range": "2ден 5ке чейинки цифрадан турган сан",
    "next": "Андан ары",
    "field_required": "Бул талааны толтуруңуз",
    "operation_failure": "Операция ийгиликтүү аяктаган жок",
    "processing": "Процесс жүрүп жатат",
    "continue": "Улантуу",
    "enter_code": "Код киргизиңиз",
    "page_not_found": "Баракча табылган жок",
    "my_docs": "Менин документтерим",
    "close": "Жабуу",
    "credit_card": {
        "card_number": "Картанын номери",
        "card_expiration_date": "Жарактуулук мөөнөтү",
        "check": "Текшерүү",
        "submit": "Ырастоо"
    },
    "repay": {
        "h3": "Көңүл бургула:",
        "h4_title": "Көңүл бургула:",
        "h4_subtitle": "Төлөм жүргүзөөр менен түшпөйт, күн тартибинде көрсөтүлгөндөн 2-3 күн эрте төлөңүздөр.",
        "h4_subtitle_2": "М Булак төлөмдөр үчүн комиссия албайт. Кандай комиссия болсо да - ал сиздин банктыкы.",
        "h4_subtitle_3": "Ошондой эле, төлөм дароо кабыл алынбай тургандыгын жана  банк тарабынан бир нече күн иштетилиши мүмкүн экенин эскертебиз",
        "h4_subtitle_4": "Төлөмдөрдү кечиктирбөө үчүн алдын ала төлөңүз.",
        "birthday": "Туулган күнү",
        "account": "ϴздүк эсеп",
        "amount": "Төлөмдүн суммасы",
        "to_main_site": "Башкы бетке",
        "check": "Текшерүү",
        "loans": "Насыялар",
        "payment": "Төлөм",
        "forgot": "Унуттуңузбу?",
        "title": "Онлайн насыяны төлөө",
        "modal": {
            "header": "Жеке эсебиңизди кантип тапса болот?",
            "p1": "Эгерде сиз өзүңүздүн жеке эсебиңизди унутуп калсаңыз, Компанияда катталган уюлдук телефондон «info» деген сөздү 8 (903) 76-76-000 номерине SMS жөнөтүңүз, сиз жеке эсебиңиздин номери бар SMS аласыз.",
            "p2": "Ошондой эле, насыя бергенде жана насыяны төлөгөндө, компанияда катталган уюлдук телефонуңузга жеке эсебиңизди көрсөтүү менен билдирүү жөнөтүлөт. «L/chet:XX»",
            "p3": "* SMS билдирүүнүн наркы оператордун тарифтик планына ылайык аныкталат."
        }
    },
    "user_docs": {
        "attach": "Тиркөө",
        "processing": "Документ иштелип жатат",
        "page": "{0}/{1} бет",
        "warning": "КӨҢҮЛ БУРУҢУЗ! Документтерди бекитүүдөн мурун, документтердин бардык сүрөттөрү булутсуз, жакшы окулбай, жаркырап же караңгыланып калбасын текшерүү керек! Эгерде документтердин көчүрмөлөрү сапат талаптарына жооп бербесе, кабыл алынбайт."
    },
    "error_unexpected": "Күтүлбөгөн ката кетти",
    "doc_view": {
        "null": "Маалыматтар жараксыз"
    },
    "choose_loan": "Сиз төлөөнү каалаган келишимди тандаңыз",
    "wrong_amount": "150 000 рублдан ашпаган сумманы көрсөтүңүздөр"
};

export const validation = {
    required: "Бул милдеттүү талаа",
    numeric: "Талаа мааниси сан ирети менен болушу керек",
    positive: "Талаа мааниси оң болушу керек",
    alpha: "Талаа мааниси сөзмө-сөз болушу керек",
    invalid_email: "Электрондук почта дарегинин форматы туура эмес",
    card_number: "Картанын номери туура эмес",
    invalid_date: "Күнү туура эмес",
    card_expired: "Картанын мөөнөтү бүттү",
    file_size: "{0} файлдын көлөмү уруксат берилген чегинен ашып кетти, {1}mb",
    file_type: "{0} файл түрү туура эмес, булардын бирин тандаңыз: {1}",
    client_account: "Жеке эсеп 2ден 5ке чейинки орундуу сандан турушу керек",
    repay_amount: "Төлөмдүн суммасы 36дан 1 000 000 рублга чейин болушу керек",
    char_length: "Талаанын узундугу {0} болушу керек",
    char_length_within: "Талаа узундугу {0} жана {1}дан азыраак болушу керек",
};
